<mat-card class="mb-3">
  <mat-card-content class="context-assignment-card-content">
    <div class="d-flex align-items-center component-header">
      <div class="flex-fill text-center">
        <h6 class="m-0 blue-text">Item Value Overrides ({{ overrides?.length || 0 }})</h6>
      </div>
    </div>
    <mat-divider class="card-divider"></mat-divider>

    <!-- Loading State -->
    @if (isLoading$ | async) {
      <div class="d-flex justify-content-center align-items-center p-5">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    }

    <!-- Content State -->
    @if (!(isLoading$ | async)) {
      <div class="accordion-container">
        @if (groupedOverrides && groupedOverrides.length > 0) {
          <mat-accordion multi="true">
            @for (group of groupedOverrides; track group) {
              <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                  <mat-panel-title
                    [matTooltip]="'Location-specific attribute value overrides for ' + group.variation">
                    {{ group.variation }}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="panel-content-wrapper">
                  <mat-divider class="mb-3"></mat-divider>
                  <div class="overflow-scroll">
                    <table mat-table [dataSource]="group.overrides" class="value-overrides__table">
                      <ng-container matColumnDef="location">
                        <th mat-header-cell *matHeaderCellDef class="value-overrides__location-cell"><b>Location</b>
                      </th>
                      <td mat-cell *matCellDef="let element" class="value-overrides__location-cell"
                        [matTooltip]="element.location">
                        <span class="value-overrides__location-text">{{ element.location }}</span>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="attribute">
                      <th mat-header-cell *matHeaderCellDef><b>Attribute</b></th>
                      <td mat-cell *matCellDef="let element"> {{ element.attribute }} </td>
                    </ng-container>
                    <ng-container matColumnDef="value">
                      <th mat-header-cell *matHeaderCellDef><b>Value</b></th>
                      <td mat-cell *matCellDef="let element"> {{ element.value }} </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                    [attr.data-row-location]="row?.location"></tr>
                  </table>
                </div>
              </div>
            </mat-expansion-panel>
          }
        </mat-accordion>
      } @else {
        <div class="p-4 text-center text-muted">
          This uses the base item & has no overrides.
        </div>
      }
    </div>
  }
</mat-card-content>
</mat-card>
